import { h, Component } from 'preact';
import { mobileTitleStyle } from './style';

export default class ChatFloatingButton extends Component {

    constructor(props) {
        super(props);
        this.state = { hovered: false };
    }

    render({ color, onClick }, { hovered }) {
        const btnStyle = {
            ...mobileTitleStyle,
            background: color,
            transform: hovered ? 'scale(1.08)' : 'scale(1)',
            transition: 'transform 0.2s ease, box-shadow 0.2s ease',
            boxShadow: hovered
                ? '0 6px 24px rgba(0,0,0,0.28)'
                : '0 4px 16px rgba(0,0,0,0.2)',
            position: 'relative',
            overflow: 'visible'
        };

        return (
            <div
                style={btnStyle}
                onClick={onClick}
                onMouseEnter={() => this.setState({ hovered: true })}
                onMouseLeave={() => this.setState({ hovered: false })}
            >
                {/* Pulse ring */}
                <div style={{
                    position: 'absolute',
                    top: '-6px', left: '-6px',
                    right: '-6px', bottom: '-6px',
                    borderRadius: '50%',
                    border: `2px solid ${color}`,
                    opacity: 0.4,
                    animation: 'pulse-ring 2s ease-out infinite',
                    pointerEvents: 'none'
                }} />

                <style>{`
                    @keyframes pulse-ring {
                        0%   { transform: scale(0.92); opacity: 0.5; }
                        70%  { transform: scale(1.15); opacity: 0; }
                        100% { transform: scale(1.15); opacity: 0; }
                    }
                `}</style>

                {/* Chat icon */}
                <svg
                    style={{ display: 'block' }}
                    width="26" height="26"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M20 2H4C2.9 2 2 2.9 2 4v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"
                        fill="#0d0d0d"
                    />
                    <path
                        d="M7 9h10M7 13h7"
                        stroke="#ffffff"
                        stroke-width="1.8"
                        stroke-linecap="round"
                    />
                </svg>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/widget/chat-floating-button.js